export const AGREEMENT_TYPES = {
  1: 'Customer',
  2: 'TermsOfUse',
  3: 'IRA',
  4: 'Fees_NonIRA',
  5: 'Fees_IRA',
  6: 'AipAgreement',
  7: 'AchAgreement',
};

export const AGREEMENT_TYPE_LABELS = {
  2: 'User Terms',
  3: 'IRA Terms',
  7: 'ACH Terms',
};

export const AGREEMENT_TYPE_PAGES = {
  'User Terms': `/terms/user`,
  'ACH Terms': `/terms/ach`,
  'IRA Terms': `/terms/ira`,
};

export const SELL_FROM_HOME_AGREEMENT_TYPE = 'SellFromHome';
